import { animate as animate3 } from "vendor";
import { Drawer } from "./theme.js";

var AddFavorite = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this._onClick);
    this.addEventListener("favorites:change", this._onChangedFavorites);
    this._onChangedFavorites();
  }
  disconnectedCallback() {
    this._abortController?.abort();
  }
  _onClick() {
    const handle = this.getAttribute("data-favorite-product-handle");
    const productTitle = this.getAttribute("data-favorite-product-title");
    const productVariantId = this.getAttribute(
      "data-favorite-product-variant-id"
    );
    const productVariantUrl = this.getAttribute(
      "data-favorite-product-variant-url"
    );
    const productVariantTitle = this.getAttribute(
      "data-favorite-product-variant-title"
    );
    const image = this.getAttribute("data-favorite-image");
    const price = this.getAttribute("data-favorite-price");

    const qtyInput = document.querySelector('input[name="quantity"]');

    // const qty = document.getElementByType().
    const product = {
      handle,
      id: productVariantId,
      product: productTitle,
      variant: productVariantTitle,
      url: productVariantUrl,
      qty: parseInt(
        typeof qtyInput !== "undefined" && qtyInput !== null
          ? qtyInput.value
          : 1
      ),
      image,
      price,
    };
    let wishlist = localStorage.getItem("tg_wishlist");
    if (wishlist === null || wishlist == null || wishlist == '"null"') {
      // wishlist = [product];
    } else {
      wishlist = JSON.parse(wishlist);
      // wishlist.push(product);
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("favorites:add", {
        bubbles: true,
        detail: {
          favorites: wishlist,
          product,
        },
      })
    );
    // localStorage.setItem("tg_wishlist", JSON.stringify(wishlist));
  }
  _onChangedFavorites() {}
};

if (!window.customElements.get("add-favorite")) {
  window.customElements.define("add-favorite", AddFavorite);
}

var FavoriteCount = class extends HTMLElement {
  constructor() {
    super();
    this._animatedUpdate = true;
    this._updatedItemCountListener = this._updatedItemCount.bind(this);
    this.attachShadow({ mode: "open" }).appendChild(
      document
        .createRange()
        .createContextualFragment("<span><slot></slot></span>")
    );
  }
  connectedCallback() {
    this._abortController = new AbortController();
    document.addEventListener(
      "favorite-variant:add",
      this._updatedItemCountListener
    );
    this._updatedItemCount(null);
  }
  disconnectedCallback() {
    document.removeEventListener(
      "favorite-variant:add",
      this._updatedItemCountListener
    );
  }
  async _updateFromServer() {
    this.itemCount = (await fetchCart)["item_count"];
  }
  get itemCount() {
    return parseInt(this.innerText);
  }
  set itemCount(count) {
    if (!this._animatedUpdate) {
      this.classList.remove("opacity-0");
      this.innerText = count;
      return;
    }
    if (count > 0) {
      this.classList.remove("opacity-0");
    }
    if (count === 0) {
      animate3(this, { opacity: 0 }, { duration: 0.1 });
      this.innerText = count;
    } else if (this.itemCount === 0) {
      animate3(this, { opacity: 1 }, { duration: 0.1 });
      this.innerText = count;
    } else {
      (async () => {
        await animate3(
          this.shadowRoot.firstElementChild,
          { transform: ["translateY(-50%)"], opacity: 0 },
          { duration: 0.25, easing: [1, 0, 0, 1] }
        ).finished;
        this.innerText = count;
        animate3(
          this.shadowRoot.firstElementChild,
          { transform: ["translateY(50%)", "translateY(0)"], opacity: 1 },
          { duration: 0.25, easing: [1, 0, 0, 1] }
        );
      })();
    }
  }
  _updatedItemCount(event) {
    this._animatedUpdate = event !== null;

    let wishlist = localStorage.getItem("tg_wishlist");
    if (wishlist == null || wishlist == '"null"') {
      wishlist = [];
    } else {
      const items = Object.entries(JSON.parse(wishlist))
        .map((item) => item[1].map((i) => i.qty))
        .flat()
        .reduce((acc, curr) => acc + curr, 0);

      if (items > 0) {
        this.itemCount = items;
      }
    }
  }
};
if (!window.customElements.get("favorite-count")) {
  window.customElements.define("favorite-count", FavoriteCount);
}

var FavoritesNotificationDrawer = class extends Drawer {
  constructor() {
    super();
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("favorites:add", this._onVariantAddedListener);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("favorites:add", this._onVariantAddedListener);
  }
  async show() {
    this.style.display = "block";
    return super.show();
  }
  async hide() {
    super.hide()?.then(() => {
      this.style.display = "none";
    });
  }
  _onVariantAdded(event) {
    if (
      window.themeVariables.settings.cartType !== "popover" ||
      event.detail?.blockCartDrawerOpening
    ) {
      return;
    }

    const productDetails = event.detail.product;

    const content = document.createElement("div");
    content.setAttribute("id", "shopify-section-variant-added");
    content.classList.add("shopify-section");
    content.classList.add("quick-buy-drawer__info");
    content.setAttribute("role", "alert");
    content.style.gridColumn = "1/-1";
    content.style.marginBottom = "1rem";

    const banner = document.createElement("div");
    banner.classList.add("banner");
    banner.classList.add("banner--success");
    banner.classList.add("justify-center");
    banner.innerHTML = `
        <svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="offset-icon icon icon-success" style="--icon-height: 18px" viewBox="0 0 18 18"><path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path><path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path></svg>
        Toegevoegd aan je verlanglijst!
    `;
    // content.append(banner);

    const product = document.createElement("div");
    product.classList.add("quick-buy-drawer__variant");
    product.classList.add("text-start");
    product.classList.add("h-stack");
    product.classList.add("gap-6");

    const image = document.createElement("img");
    image.classList.add("quick-buy-drawer__media");
    image.classList.add("rounded-xs");
    image.setAttribute("alt", productDetails.product);
    image.setAttribute("src", productDetails.image);
    product.append(image);

    const info = document.createElement("div");
    info.classList.add("v-stack");
    info.classList.add("gap-1");

    const list = document.createElement("div");
    list.classList.add("v-stack");
    list.classList.add("gap-0.5");

    const link = document.createElement("div");
    link.classList.add("bold");
    link.classList.add("justify-self-start");
    link.innerHTML = productDetails.product;
    list.append(link);

    const price = document.createElement("div");
    price.setAttribute(
      "style",
      "display: flex; width: 100%; gap: var(--spacing-3);"
    );
    price.innerHTML =
      '<div style="flex: 30%;"><price-list class="price-list"><sale-price class="text-subdued"><span class="sr-only">Aanbiedingsprijs</span>' +
      productDetails.price +
      "</sale-price></price-list></div>";

    list.append(price);

    info.append(list);

    const variant = document.createElement("p");
    variant.classList.add("text-sm");
    variant.classList.add("text-subdued");
    variant.innerHTML = productDetails.variant;

    info.append(variant);

    product.append(info);

    content.append(product);

    // Choose list

    let wishlist = localStorage.getItem("tg_wishlist");
    const rooms = [];
    if (wishlist != null && wishlist != '"null"') {
      Object.keys(JSON.parse(wishlist)).forEach((room) => rooms.push(room));
    }
    const listSelect = document.createElement("div");

    const listLabel = document.createElement("label");
    listLabel.setAttribute("style", "display: flex;");
    listLabel.classList.add("block-label");
    listLabel.classList.add("text-subdued");
    listLabel.innerHTML = "Kies een ruimte";
    listLabel.innerHTML =
      rooms.length == 0 ? "Voor welke ruimte is dit?" : "Kies een ruimte";
    listSelect.append(listLabel);

    const listInputWrapper = document.createElement("div");
    listInputWrapper.classList.add("quantity-selector");
    listInputWrapper.setAttribute("style", "width: 100%;");

    const newListInput = document.createElement("input");
    newListInput.setAttribute("type", "text");
    newListInput.setAttribute("placeholder", "Vul de ruimte naam in");
    newListInput.setAttribute(
      "style",
      "width: 100%; text-indent: 8px;" +
        (rooms.length > 0 ? " display: none;" : "")
    );

    listInputWrapper.append(newListInput);

    const roomSelect = document.createElement("select");
    // newListInput.setAttribute("type", "text");
    // newListInput.setAttribute("placeholder", "Vul de ruimte naam in");
    roomSelect.setAttribute(
      "style",
      "width: 100%; margin: 0 8px;" +
        (rooms.length == 0 ? " display: none;" : "")
    );

    rooms.forEach((room) => {
      const roomSelectOption = document.createElement("option");
      roomSelectOption.setAttribute("value", room);
      roomSelectOption.innerHTML = room;
      roomSelect.append(roomSelectOption);
    });
    const roomSelectOption = document.createElement("option");
    roomSelectOption.setAttribute("value", "");
    roomSelectOption.innerHTML = "Andere ruimte";
    roomSelect.append(roomSelectOption);

    roomSelect.addEventListener("change", (event) => {
      if (event.target.value == "") {
        roomSelect.setAttribute("style", "display: contents;");
        newListInput.setAttribute(
          "style",
          "display: block; width: 100%; text-indent: 8px;"
        );
        listLabel.innerHTML = "Nieuwe ruimte";
        newListInput.focus();
      }
    });

    listInputWrapper.append(roomSelect);
    listSelect.append(listInputWrapper);

    content.append(listSelect);

    const buttons = document.createElement("div");
    buttons.classList.add("buy-buttons");
    buttons.classList.add("buy-buttons--compact");

    const button = document.createElement("div");
    button.setAttribute("style", "cursor: pointer;");
    // button.setAttribute("data-no-instant", "");
    // button.setAttribute("aria-controls", "favorites-drawer");
    button.classList.add("button");
    button.classList.add("button--outline");
    button.classList.add("button--secondary");
    button.innerHTML = "Toevoegen aan verlanglijst";
    button.addEventListener("click", () => {
      let roomName = roomSelect.value;

      if (roomName == "" && newListInput.value.trim() == "") {
        alert("Vul de ruimte naam in aub.");
      } else {
        const room = roomSelect.value || newListInput.value;

        let wishlist = localStorage.getItem("tg_wishlist");
        if (wishlist == null || wishlist == '"null"') {
          wishlist = {};
        } else {
          wishlist = JSON.parse(wishlist);
        }
        if (typeof wishlist[room] === "undefined") {
          wishlist[room] = [];
        }

        const existingIndex = wishlist[room].findIndex(
          (product) =>
            product.handle === productDetails.handle &&
            product.variant === productDetails.variant
        );

        if (existingIndex === -1) {
          wishlist[room].push(productDetails);
        } else {
          wishlist[room][existingIndex].qty =
            wishlist[room][existingIndex].qty + productDetails.qty;
        }
        localStorage.setItem("tg_wishlist", JSON.stringify(wishlist));

        // Dispatch event to update counter
        document.documentElement.dispatchEvent(
          new CustomEvent("favorite-variant:change", {
            bubbles: true,
            detail: {},
          })
        );

        // Dispatch event to update list in drawer
        document.documentElement.dispatchEvent(
          new CustomEvent("favorite-variant:add", {
            bubbles: true,
            detail: {},
          })
        );

        // Dispatch event to show drawer
        document.documentElement.dispatchEvent(
          new CustomEvent("favorite-variant:show", {
            bubbles: true,
            detail: {},
          })
        );

        this.hide();
      }
    });

    buttons.append(button);

    content.append(buttons);

    const container = document.createElement("div");
    container.classList.add("quick-buy-drawer__info");
    container.append(content);

    this.replaceChildren(...container.children);
    this.show();
  }
};
if (!window.customElements.get("favorites-notification-drawer")) {
  window.customElements.define(
    "favorites-notification-drawer",
    FavoritesNotificationDrawer
  );
}

var FavoritesDrawer = class extends Drawer {
  constructor() {
    super();
    this._onPrepareBundledSectionsListener =
      this._onPrepareBundledSections.bind(this);
    this._onCartChangedListener = this._onCartChanged.bind(this);
    this._onCartRefreshListener = this._onCartRefresh.bind(this);
    this._onVariantAddedListener = this._onVariantAdded.bind(this);
    this._onHideListener = this._onHide.bind(this);
    window.addEventListener("pageshow", this._onPageShow.bind(this));
    this._loadFavoritesList();
  }
  connectedCallback() {
    super.connectedCallback();
    this._abortController = new AbortController();
    document.addEventListener(
      "cart:prepare-bundled-sections",
      this._onPrepareBundledSectionsListener
    );
    document.addEventListener("favorites:hide", this._onHideListener);
    document.addEventListener("cart:change", this._onCartChangedListener);
    document.addEventListener("cart:refresh", this._onCartRefreshListener);
    document.addEventListener("favorite-variant:add", this._loadFavoritesList);
    document.addEventListener(
      "favorite-variant:show",
      this._onVariantAddedListener
    );
    this.querySelector("button#add-list-to-cart").addEventListener(
      "click",
      (event) => this.addListToCart(event),
      { signal: this._abortController.signal }
    );
  }
  addListToCart(event) {
    event.preventDefault();
    let wishlist = localStorage.getItem("tg_wishlist");
    if (wishlist === null) {
      wishlist = {};
    } else {
      wishlist = JSON.parse(wishlist);
    }
    const items = [];
    Object.keys(wishlist).forEach((room, index) => {
      wishlist[room].forEach((data) => {
        items.push(`${data.id}:${data.qty}`);
      });
    });
    location.href = `/cart/${items.join(",")}`;
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      "cart:prepare-bundled-sections",
      this._onPrepareBundledSectionsListener
    );
    document.removeEventListener("favorites:hide", this._onHideListener);
    document.removeEventListener("cart:change", this._onCartChangedListener);
    document.removeEventListener("cart:refresh", this._onCartRefreshListener);
    document.removeEventListener(
      "favorite-variant:add",
      this._loadFavoritesList
    );
    document.removeEventListener(
      "favorite-variant:show",
      this._onVariantAddedListener
    );
  }
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return "right";
  }
  _loadFavoritesList() {
    let wishlist = localStorage.getItem("tg_wishlist");
    if (wishlist === null || wishlist == null || wishlist == '"null"') {
      wishlist = {};
    } else {
      wishlist = JSON.parse(wishlist);
    }

    const isEmpty = Object.keys(wishlist).length === 0;

    let elements = document.getElementsByClassName("favorites-is-empty");
    for (let i = 0; i < elements.length; i++) {
      let element = elements[i];
      if (!isEmpty) {
        element.setAttribute("style", "display: none;");
      } else {
        element.removeAttribute("style");
      }
    }

    // elements = document.getElementsByClassName("favorites-is-not-empty");
    // for (let i = 0; i < elements.length; i++) {
    //   let element = elements[i];
    //   if (!isEmpty) {
    //     element.removeAttribute("style");
    //   } else {
    //     element.setAttribute("style", "display: none;");
    //   }
    // }

    setTimeout(function () {
      if (typeof this.shadowRoot !== "undefined") {
        if (!isEmpty) {
          this.shadowRoot.querySelector("footer").removeAttribute("style");
        } else {
          this.shadowRoot
            .querySelector("footer")
            .setAttribute("style", "display: none;");
        }
      }
    }, 500);

    const container = document.getElementById("favorites-list");
    container.innerHTML = "";

    Object.keys(wishlist).forEach((room, index) => {
      const roomElement = document.createElement("div");
      roomElement.classList.add("h-stack");
      roomElement.classList.add("items-center");
      roomElement.classList.add("justify-between");

      const titleContainer = document.createElement("div");
      titleContainer.classList.add("h-stack");
      titleContainer.classList.add("grow");
      titleContainer.classList.add("gap-2");
      titleContainer.classList.add("sm:gap-2.5");

      const title = document.createElement("p");
      title.classList.add("h5");
      title.innerHTML = room;

      titleContainer.append(title);

      roomElement.append(titleContainer);

      if (index === 0) {
        const button = document.createElement("button");
        button.setAttribute("type", "button");
        button.addEventListener("click", () => {
          document.documentElement.dispatchEvent(
            new CustomEvent("favorites:hide", {
              bubbles: true,
              detail: {},
            })
          );
        });
        button.innerHTML =
          '<svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path></svg>';

        roomElement.append(button);
        // <button type="button" is="close-button" class="drawer__close-icon">
        //   <span class="sr-only">{{ 'general.accessibility.close' | t }}</span>
        //   {%- render 'icon' with 'close' -%}
        // </button>
      }

      const items = document.createElement("div");
      items.classList.add("cart-drawer__line-items");

      let itemRoomCount = 0;

      //Add products
      wishlist[room].forEach((data) => {
        itemRoomCount += parseInt(data.qty);

        const product = document.createElement("line-item");
        product.classList.add("line-item");

        const image = document.createElement("div");
        image.classList.add("line-item__media-wrapper");

        const img = document.createElement("img");
        img.classList.add("line-item__media");
        img.classList.add("rounded-xs");
        img.setAttribute("sizes", "(max-width: 740px) 80px, 96px");
        img.setAttribute("src", data.image);
        image.append(img);
        product.append(image);

        const info = document.createElement("div");
        info.classList.add("line-item__info");

        const productName = document.createElement("div");
        productName.classList.add("v-stack");
        productName.classList.add("gap-0.5");

        const productLink = document.createElement("a");
        productLink.classList.add("bold");
        productLink.setAttribute("href", data.url);
        productLink.innerHTML =
          '<span class="reversed-link hover:show">' + data.product + "</span>";

        productName.append(productLink);

        const price = document.createElement("div");
        price.setAttribute(
          "style",
          "display: flex; width: 100%; gap: var(--spacing-3);"
        );
        price.innerHTML =
          '<div style="flex: 30%;"><price-list class="price-list"><sale-price class="text-subdued"><span class="sr-only">Aanbiedingsprijs</span>' +
          data.price +
          "</sale-price></price-list></div>";
        productName.append(price);

        info.append(productName);

        const description = document.createElement("div");
        description.classList.add("text-sm");
        description.classList.add("text-subdued");
        description.innerHTML = data.variant;
        info.append(description);

        product.append(info);

        const actions = document.createElement("div");
        actions.classList.add("line-item__actions");
        actions.classList.add("text-subdued");
        actions.classList.add("hidden");
        actions.classList.add("sm:block");

        const qty = document.createElement("line-item-quantity");
        qty.classList.add("v-stack");
        qty.classList.add("gap-2");
        actions.append(qty);

        const input = document.createElement("input");
        input.classList.add("quantity-input");
        input.setAttribute("type", "text");
        input.setAttribute("is", "quantity-input");
        input.setAttribute("input-mode", "number");
        input.setAttribute("value", data.qty);
        input.addEventListener("change", function (event) {
          const quantity = parseInt(event.target.value);
          if (isNaN(quantity) || quantity <= 0) {
            return;
          }

          let wl = localStorage.getItem("tg_wishlist");

          if (wl === null || wl == null || wl == '"null"') {
            wl = {};
          } else {
            wl = JSON.parse(wl);
          }

          if (typeof wl[room] !== "undefined") {
            let list = wl[room];
            list.forEach((product, index) => {
              if (
                product.handle === data.handle &&
                product.variant === data.variant
              ) {
                list[index].qty = parseInt(event.target.value);
              }
            });
            wl[room] = list;
            localStorage.setItem("tg_wishlist", JSON.stringify(wl));

            // Dispatch event to update list in drawer
            document.documentElement.dispatchEvent(
              new CustomEvent("favorite-variant:add", {
                bubbles: true,
                detail: {},
              })
            );
          }
        });
        qty.append(input);

        const remove = document.createElement("span");
        remove.classList.add("text-xs");
        remove.classList.add("text-center");

        const removeLink = document.createElement("a");
        removeLink.classList.add("link");
        removeLink.setAttribute("href", "void:;");
        removeLink.innerHTML = "Verwijderen";

        removeLink.addEventListener("click", function () {
          let wl = localStorage.getItem("tg_wishlist");
          if (wl === null) {
            wl = {};
          } else {
            wl = JSON.parse(wl);
          }

          if (typeof wl[room] !== "undefined") {
            let list = wl[room];
            list.forEach((product, index) => {
              if (
                product.handle === data.handle &&
                product.variant === data.variant
              ) {
                list.splice(index, 1);
              }
            });
            if (list.length <= 0) {
              delete wl[room];
            } else {
              wl[room] = list;
            }
            localStorage.setItem("tg_wishlist", JSON.stringify(wl));

            // Dispatch event to update list in drawer
            document.documentElement.dispatchEvent(
              new CustomEvent("favorite-variant:add", {
                bubbles: true,
                detail: {},
              })
            );
          }
        });

        remove.append(removeLink);

        qty.append(remove);

        product.append(actions);

        items.append(product);
      });

      const count = document.createElement("div");
      count.classList.add("count-bubble");
      count.classList.add("count-bubble--md");
      count.innerHTML = itemRoomCount;
      titleContainer.append(count);

      container.append(roomElement);
      container.append(items);
    });
  }
  _onHide(event) {
    this.hide();
  }
  _onPrepareBundledSections(event) {
    event.detail.sections.push(extractSectionId(this));
  }
  /**
   * Update the cart drawer content when cart content changes.
   */
  async _onCartChanged(event) {
    const updatedDrawerContent = new DOMParser().parseFromString(
      event.detail.cart["sections"][extractSectionId(this)],
      "text/html"
    );
    if (event.detail.cart["item_count"] > 0) {
      const currentInner = this.querySelector(".cart-drawer__inner"),
        updatedInner = updatedDrawerContent.querySelector(
          ".cart-drawer__inner"
        );
      if (!currentInner) {
        this.replaceChildren(
          document
            .createRange()
            .createContextualFragment(
              updatedDrawerContent.querySelector(".cart-drawer").innerHTML
            )
        );
      } else {
        setTimeout(
          () => {
            currentInner.innerHTML = updatedInner.innerHTML;
          },
          event.detail.baseEvent === "variant:add" ? 0 : 1250
        );
        this.querySelector('[slot="footer"]').replaceChildren(
          ...updatedDrawerContent.querySelector('[slot="footer"]').childNodes
        );
      }
    } else {
      await animate4(this.children, { opacity: 0 }, { duration: 0.15 })
        .finished;
      this.replaceChildren(
        ...updatedDrawerContent.querySelector(".cart-drawer").childNodes
      );
      animate4(
        this.querySelector(".empty-state"),
        { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] },
        { duration: 0.15 }
      );
    }
  }
  /**
   * Handle the case when the page is served from BF cache
   */
  _onPageShow(event) {
    if (!event.persisted) {
      return;
    }
    this._onCartRefresh();
  }
  /**
   * Listeners called when a new variant has been added
   */
  _onVariantAdded(event) {
    this.show();
  }
  /**
   * Force a complete refresh of the cart drawer (this is called by dispatching the 'cart:refresh' on the document)
   */
  async _onCartRefresh() {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = await (
      await fetch(
        `${window.Shopify.routes.root}?section_id=${extractSectionId(this)}`
      )
    ).text();
    this.replaceChildren(...tempDiv.querySelector("#cart-drawer").children);
  }
};
if (!window.customElements.get("favorites-drawer")) {
  window.customElements.define("favorites-drawer", FavoritesDrawer);
}
export { AddFavorite };
